import formatDate from './formatDate';

const kmMetrics = ({ id, url, type }) => {
    window.dataRequest = window.dataRequest || [];

    const date = formatDate({ date: new Date(), preset: 'local', tz: 'Europe/Moscow' });

    window.dataRequest.push({ id, url, date, type });

    const onUnload = () => {
        fetch('https://begu.ru/api/v1/project/statistics/banners/store', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Host-slug': 'on',
                'Project-slug': 'on',
                'KM-Authenticate': '282523321a7fc1a7bc7766c3e04be2d5',
            },
            body: JSON.stringify(window.dataRequest),
            keepalive: true,
        });
    };

    if (!window.__BANNER_UNLOAD__) {
        window.addEventListener('unload', onUnload);
        window.__BANNER_UNLOAD__ = true;
    }
};

export default kmMetrics;
